import React from "react";

import fundwalelogo from "../../assets/images/Fundswalle_Logo.png"
const AadhaarVerificationPage = ({
  mode,
  screen,

  aadhaarNumber,
  setAadhaarNumber,

  aadhaarError,
  setAadhaarError,

  aadhaarStatus,

  aadhaarConsent,
  setAadhaarConsent,

  aadhaarSending,

  checkAadhaarOnEnter,
  submitAadhaar,

  setAadhaarReferenceSecure,

  setScreen,

  sheet,
  closeSheet,

  aadhaarOtpDigits,
  aadhaarOtpRefs,

  handleAadhaarOtpChange,
  handleAadhaarOtpKeyDown,

  aadhaarResendTimer,
  resendAadhaarOtp,

  aadhaarOtpError,

  verifyAadhaarOtp,
  aadhaarOtpVerifying,

  formatAadhaarDisplay,
}) => {
  return (
    <>
 
      {mode === "page" && screen === "aadhaarKyc" && (
        
        <section className="fw-screen fw-screen--form fw-screen--aadhaar fw-fade">
     <div className="fw-brandmain">
          <img 
            src={fundwalelogo} 
            alt="Fundswalle" 
            className="fw-brand__logo1" 
          />
        </div>
          <h1 className="fw-title">Aadhaar Verification</h1>

          <p className="fw-sub fw-aadhaar__sub">
            Enter your Aadhaar number to verify identity. Please match details
            with your Aadhaar card.
          </p>

          <label className="fw-field">
            <span>Enter your Aadhaar Number</span>

            <input
              type="tel"
              inputMode="numeric"
              maxLength={14}
              placeholder="XXXX XXXX XXXX"
              value={formatAadhaarDisplay(aadhaarNumber)}
              disabled={aadhaarSending}
              onChange={(e) => {
                const next = e.target.value
                  .replace(/\D/g, "")
                  .slice(0, 12);

                setAadhaarNumber(next);

                if (next.length !== 12) {
                 setAadhaarError("")
                  setAadhaarReferenceSecure("");
                    return;
                }
checkAadhaarOnEnter(next);    
              }}
            />

            {aadhaarSending && (
              <em className="fw-field__info">
                Checking Aadhaar...
              </em>
            )}

            {!aadhaarSending && aadhaarError && (
              <em className="fw-error">
                {aadhaarError}
              </em>
            )}

            {!aadhaarSending &&
              !aadhaarError &&
              aadhaarStatus && (
                <em className="fw-field__ok">
                  {aadhaarStatus}
                </em>
              )}
          </label>

          <label className="fw-check fw-aadhaar-consent">
            <input
              type="checkbox"
              checked={aadhaarConsent}
              onChange={() => {
                setAadhaarConsent((prev) => !prev);
                setAadhaarError("");
              }}
            />

            <span>
              I authorize <b>Aadhaar verification</b> and receipt of{" "}
              <b>digital communications</b>.
            </span>
          </label>

          {/* Masked Aadhaar confirm card removed — OTP verify navigates to employment */}

          <div className="fw-actions">
            <button
              type="button"
              className="fw-btn fw-btn--ghost"
              onClick={() => {
                setScreen("/apply-new/details");
              }}
            >
              Back
            </button>

            <button
              type="button"
              className="fw-btn fw-btn--primary"
              onClick={submitAadhaar}
              disabled={
                aadhaarSending ||
                aadhaarNumber.length !== 12 ||
                !!aadhaarError
              }
            >
              {aadhaarSending ? "Sending OTP..." : "Proceed"}
            </button>
          </div>
        </section>
      )}

{mode === "otp" && sheet === "aadhaarOtp" && (
  <>
    <h2>Enter Aadhaar OTP</h2>

    <p className="fw-sheet__sub">
      OTP sent to the mobile number linked with Aadhaar{" "}
      {/* <b>{formatAadhaarDisplay(aadhaarNumber)}</b> */}
        <b>XXXX XXXX {String(aadhaarNumber || "").slice(-4)}</b>
    </p>

    <div className="fw-otp">
      {aadhaarOtpDigits.map((digit, index) => (
        <input
          key={`aadhaar-otp-${index}`}
          ref={(el) => {
            aadhaarOtpRefs.current[index] = el;
          }}
          inputMode="numeric"
          maxLength={1}
          value={digit}
          placeholder="0"
          onChange={(e) =>
            handleAadhaarOtpChange(
              index,
              e.target.value
            )
          }
          onKeyDown={(e) =>
            handleAadhaarOtpKeyDown(index, e)
          }
        />
      ))}
    </div>

    <p className="fw-resend">
      Have not received your OTP?{" "}

      {aadhaarResendTimer > 0 ? (
        <span>
          Resend in {aadhaarResendTimer} seconds
        </span>
      ) : (
        <button
          type="button"
          onClick={resendAadhaarOtp}
          disabled={aadhaarSending}
        >
          {aadhaarSending
            ? "Sending..."
            : "Resend OTP"}
        </button>
      )}
    </p>

    {aadhaarOtpError && (
      <p className="fw-error">
        {aadhaarOtpError}
      </p>
    )}

    <div className="fw-actions">
      <button
        type="button"
        className="fw-btn fw-btn--ghost"
        onClick={closeSheet}
      >
        Cancel
      </button>

      <button
        type="button"
        className="fw-btn fw-btn--primary"
        onClick={verifyAadhaarOtp}
        disabled={
          aadhaarOtpVerifying ||
          aadhaarOtpDigits.join("").length !== 6
        }
      >
        {aadhaarOtpVerifying
          ? "Verifying..."
          : "Verify"}
      </button>
    </div>
  </>
)}
    </>
  );
};

export default AadhaarVerificationPage;